import { CMSApiResponse }                  from "framework/http/CMSApiClient";
import { RunContextApp }                      from "framework/RCApp";
import { GetHomeProfileAttributes, 
         GetPilotHomeProfile, 
         UpdatePilotHomeProfile 
       }                                      from "types/apis/homeProfileInterfaces";

export const HomeProfileAPI = {

  getHomeProfileAttributes : async (rc : RunContextApp) : Promise<CMSApiResponse<GetHomeProfileAttributes.retval>> => {
    const resp = await rc.cmsApiClient.get<GetHomeProfileAttributes.retval>(`/home-profile-attribute/getHomeProfileAttributes`)
    return resp
  },

  getPilotHomeProfile : async (rc : RunContextApp, utilityDocId : string) : Promise<CMSApiResponse<GetPilotHomeProfile.retval>> => {

    const resp = await rc.cmsApiClient.get<GetPilotHomeProfile.retval>(`/utility/getHomeProfile?utilityDocumentId=${utilityDocId}`)
    return resp
  },

  updatePilotHomeProfile : async (rc : RunContextApp, utilityDocId : string, profileData : UpdatePilotHomeProfile.params) : Promise<CMSApiResponse<UpdatePilotHomeProfile.retval>> => {

    const resp = await rc.cmsApiClient.post<UpdatePilotHomeProfile.retval>(`/utility/updateHomeProfile`, {
      utilityDocumentId : utilityDocId,
      profile : profileData
    })
    return resp
  }
}
